<script setup lang="ts">
  const { t, tmResolved } = useResolvedI18n()
  const localePath = useLocalePath()
  useHead({ title: () => t('programs.title') })

  type CourseItem = { label: string; desc: string }

  const adCourses = computed(() => tmResolved<CourseItem[]>('programs.ad.courses'))
  const icCourses = computed(() => tmResolved<CourseItem[]>('programs.ic.courses'))
</script>

<template>
  <section
    class="page-banner"
    style="
      background-image: url('https://www.sanyau.edu.cn/_upload/article/images/75/d2/485c4d00481380f2b78cb06ddf70/df1c9875-2059-4469-8909-9a323c2c17db.jpg');
    "
  >
    <h2>{{ t('programs.banner') }}</h2>
    <div class="breadcrumb">
      <NuxtLink :to="localePath('/')">{{ t('common.home') }}</NuxtLink>
      &gt; {{ t('programs.breadcrumb') }}
    </div>
  </section>

  <section class="content-section">
    <div class="container">
      <div class="content-wrapper">
        <div class="content-main">
          <!-- 智能驾驶专业 -->
          <div class="content-card" id="ad">
            <h3>{{ t('programs.ad.title') }}</h3>
            <p>{{ t('programs.ad.intro') }}</p>

            <h4 style="font-size: 17px; color: var(--theme-blue); margin: 20px 0 10px">
              {{ t('programs.ad.directionTitle') }}
            </h4>
            <p style="text-indent: 0">{{ t('programs.ad.direction') }}</p>

            <h4 style="font-size: 17px; color: var(--theme-blue); margin: 20px 0 10px">
              {{ t('programs.ad.platformTitle') }}
            </h4>
            <p style="text-indent: 0">{{ t('programs.ad.platform') }}</p>

            <h4 style="font-size: 17px; color: var(--theme-blue); margin: 20px 0 10px">
              {{ t('programs.ad.degreeTitle') }}
            </h4>
            <p style="text-indent: 0">{{ t('programs.ad.degree') }}</p>

            <h4 style="font-size: 17px; color: var(--theme-blue); margin: 20px 0 10px">
              {{ t('programs.ad.coursesTitle') }}
            </h4>
            <ul>
              <li v-for="(item, i) in adCourses" :key="i">
                <strong>{{ item.label }}</strong>
                {{ item.desc }}
              </li>
            </ul>

            <h4 style="font-size: 17px; color: var(--theme-blue); margin: 20px 0 10px">
              {{ t('programs.ad.careerTitle') }}
            </h4>
            <p style="text-indent: 0">{{ t('programs.ad.career') }}</p>
          </div>

          <!-- 智能座舱专业 -->
          <div class="content-card" id="ic">
            <h3>{{ t('programs.ic.title') }}</h3>
            <p>{{ t('programs.ic.intro') }}</p>

            <h4 style="font-size: 17px; color: var(--theme-blue); margin: 20px 0 10px">
              {{ t('programs.ic.directionTitle') }}
            </h4>
            <p style="text-indent: 0">{{ t('programs.ic.direction') }}</p>

            <h4 style="font-size: 17px; color: var(--theme-blue); margin: 20px 0 10px">
              {{ t('programs.ic.platformTitle') }}
            </h4>
            <p style="text-indent: 0">{{ t('programs.ic.platform') }}</p>

            <h4 style="font-size: 17px; color: var(--theme-blue); margin: 20px 0 10px">
              {{ t('programs.ic.degreeTitle') }}
            </h4>
            <p style="text-indent: 0">{{ t('programs.ic.degree') }}</p>

            <h4 style="font-size: 17px; color: var(--theme-blue); margin: 20px 0 10px">
              {{ t('programs.ic.coursesTitle') }}
            </h4>
            <ul>
              <li v-for="(item, i) in icCourses" :key="i">
                <strong>{{ item.label }}</strong>
                {{ item.desc }}
              </li>
            </ul>

            <h4 style="font-size: 17px; color: var(--theme-blue); margin: 20px 0 10px">
              {{ t('programs.ic.careerTitle') }}
            </h4>
            <p style="text-indent: 0">{{ t('programs.ic.career') }}</p>
          </div>
        </div>

        <!-- Sidebar -->
        <aside class="content-sidebar">
          <div class="sidebar-nav">
            <h4>{{ t('programs.sidebar.navTitle') }}</h4>
            <ul>
              <li>
                <a href="#ad">{{ t('programs.sidebar.navAd') }}</a>
              </li>
              <li>
                <a href="#ic">{{ t('programs.sidebar.navIc') }}</a>
              </li>
            </ul>
          </div>
          <div class="sidebar-nav">
            <h4>{{ t('common.quickLinks') }}</h4>
            <ul>
              <li>
                <NuxtLink :to="localePath('/education')">{{ t('programs.sidebar.linkEducation') }}</NuxtLink>
              </li>
              <li>
                <NuxtLink :to="localePath('/admission')">{{ t('programs.sidebar.linkAdmission') }}</NuxtLink>
              </li>
              <li>
                <NuxtLink :to="localePath('/faculty')">{{ t('programs.sidebar.linkFaculty') }}</NuxtLink>
              </li>
            </ul>
          </div>
        </aside>
      </div>
    </div>
  </section>
</template>
